import { ReactiveComponent } from "../../core/ReactiveComponent.core";
import { ICON } from "../Icons/Icons";

class UserActivity extends ReactiveComponent {
  constructor({ activeState = null, container = null, onIconClick = null }) {
    // Create a temporary container if none provided
    const tempContainer = container || $('<div>');

    // Call parent constructor with the container
    super(tempContainer, { activeState });

    this.container = container || tempContainer;
    this.element = null;
    this.onIconClick = onIconClick;

    this.init();
  }

  init() {
    this.setupReactiveBindings();
    this.render();
  }

  setupReactiveBindings() {
    // Bind the activeState to render function
    this.bindState('activeState', (newState) => {
      this.render();
    });

    // Watch for state changes
    this.watch('activeState', (newState, oldState) => {
    });
  }

  setActiveState(newState) {
    if (this.state.activeState !== newState) {
      this.state.activeState = newState;
    }
  }

  getIconForState(state) {
    const iconMap = {
      'meeting': ICON.ICON_MEETING,
      'game': ICON.CHESS_HORSE,
      'chess': ICON.CHESS_HORSE,
      'tour': ICON.TOUR,
      "settings": ICON.CONFIG,
      "none": ICON.EYE,
      "chess-red": ICON.CHESS_HORSE,
      "chess-blue": ICON.CHESS_HORSE,
    };

    const icon = iconMap[state];
    return icon || '';
  }

  render() {
    if (!this.container) {
      console.error('UserActivity: container is required');
      return;
    }

    // Clear existing content
    this.container.empty();

    // If no active state, don't render anything
    if (!this.state.activeState) {
      return;
    }

    // Hide icon when state is 'none'
    if (this.state.activeState === 'none') {
      return;
    }

    const iconSvg = this.getIconForState(this.state.activeState);

    if (!iconSvg) {
      console.warn(`UserActivity: No icon found for state "${this.state.activeState}"`);
      return;
    }

    // Create the wrapper div with conditional classes
    const baseClasses = 'icon-wrapper icon-arrow-down-wrapper';
    const greenClass = this.state.activeState !== 'none' ? 'always-green' : '';
    const redClass = this.state.activeState === 'chess-red' ? 'always-red' : '';
    const blueClass = this.state.activeState === 'chess-blue' ? 'always-blue' : '';

    const allClasses = `${baseClasses} ${greenClass} ${redClass} ${blueClass}`;

    this.element = $(`<div class="${allClasses}" data-activity="${this.state.activeState}"></div>`);
    this.element.html(iconSvg);

    // Bind click callback if provided
    if (typeof this.onIconClick === 'function') {
      this.element.on('click', (event) => {
        try {
          this.onIconClick({ state: this.state.activeState, event });
        } catch (err) {
          console.error('UserActivity onIconClick error:', err);
        }
      });
    }

    // Append to container
    this.container.append(this.element);
  }

  // Override destroy to clean up properly
  destroy() {
    if (this.element) {
      this.element.remove();
      this.element = null;
    }

    // Call parent destroy
    super.destroy();
  }
}

export default UserActivity;
